module.exports = __webpack_public_path__ + "img/logo_latvianmn.ee0418b0.png";